import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { Accountbankinfo } from '@core/models/admin/account';
import { CommonService } from '@core/services/common.service';
import { KycAccordionComponent } from '@shared/ui/kyc-accordion/kyc-accordion.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-ind-bank-details',
  standalone: true,
  imports: [KycAccordionComponent, CommonModule],
  templateUrl: './ind-bank-details.component.html',
  styleUrl: './ind-bank-details.component.scss',
})
export class IndBankDetailsComponent {
  @Input() bankDetails!: Accountbankinfo[];
  @Input() bankName!: string;

  isKycComplete: boolean = false;
  subs: Subscription[] = [];
  banks: { bankName: string; bankCode: string }[] = [];

  commonService = inject(CommonService);

  ngOnInit(): void {
    this.checkKycStatus();
    this.getBankList();
  }

  getBankList() {
    const sub = this.commonService.getBankList().subscribe({
      next: (res) => {
        this.banks = res.data;
      },
      error: (error) => {
        console.error('Error fetching bank list:', error);
      },
    });
    this.subs.push(sub);
  }

  getBankName(bankCode: string) {
    const bank = this.banks.find((bank) => bank.bankCode === bankCode);
    return bank ? bank.bankName : '-';
  }

  private checkKycStatus(): void {
    if (!this.bankDetails || this.bankDetails.length === 0) {
      this.isKycComplete = false;
      return;
    }

    this.isKycComplete = this.bankDetails.every(
      (acc) => acc.bank_account_name && acc.bank_account_number && acc.currency
    );
  }

  ngOnDestroy(): void {
    this.subs.forEach((sub) => sub.unsubscribe());
  }
}
